var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Grid, NoGridData } from '../../../../components/shared';
import React, { useMemo } from 'react';
import { DefaultLoadingComponent } from '../default-loading-component';
import { useAppSelector } from '../../../../components/app/hooks';
import { loaderConstant } from '../../../../shared/types/constants';
import '../loader.scss';
export var LoaderForTable = function (_a) {
    var _b;
    var Component = _a.Component, isLoading = _a.isLoading, _c = _a.countOfLoaderRows, countOfLoaderRows = _c === void 0 ? 5 : _c, props = __rest(_a, ["Component", "isLoading", "countOfLoaderRows"]);
    var isLoaderEnabled = useAppSelector(function (state) { return state.loadingStore.isLoaderEnabled; });
    var _columns = useMemo(function () {
        var _a, _b;
        return (_b = (_a = Component === null || Component === void 0 ? void 0 : Component.props) === null || _a === void 0 ? void 0 : _a.columns) === null || _b === void 0 ? void 0 : _b.map(function (ele) { return (__assign(__assign({}, ele), { render: function (column, row) {
                return (React.createElement("div", { style: { padding: '15px 0', borderBottom: '0 !important', boxShadow: 'none !important' } },
                    React.createElement(DefaultLoadingComponent, { count: 1, height: 10 })));
            } })); });
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { display: isLoading ? 'none' : 'inherit' } }, Component),
        isLoading && (React.createElement(Grid, __assign({}, ((_b = Component === null || Component === void 0 ? void 0 : Component.props) !== null && _b !== void 0 ? _b : {}), { columns: _columns !== null && _columns !== void 0 ? _columns : [], extendClass: "additional", rowData: __spreadArray([], new Array(countOfLoaderRows), true).map(function (ele, index) { return index; }), noRowsMessage: isLoaderEnabled ? (React.createElement(NoGridData, { image: 'no-image', message: React.createElement(DefaultLoadingComponent, __assign({ height: 65 }, props)) })) : (React.createElement(NoGridData, { image: 'no-clients', message: loaderConstant.loadingText })) })))));
};
